import { TownsquareGoalAri, TownsquareProjectAri } from '@atlassian/ari/townsquare';

export function getSiteId(entity: 'project' | 'goal', ari: string): string {
	try {
		if (entity === 'goal') {
			return TownsquareGoalAri.parse(ari).siteId;
		}

		if (entity === 'project') {
			return TownsquareProjectAri.parse(ari).siteId;
		}
	} catch (error) {
		//TODO: send error metrics/monitoring https://product-fabric.atlassian.net/browse/TC-13492

		//We try to extract the siteId manually: ari:cloud:townsquare:${siteId}:{entity}/{uuid}
		return ari.split(':')[3] ?? '';
	}
	return ari.split(':')[3] ?? '';
}
